const workflowEventsList = [
  {
    key: 'INDENT_CREATION',
    name: 'Indent Creation',
    status_id: 0, // Indented
    mandatory: true,
    isSelected: true,
  },
  {
    key: 'VEHICLE_ASSIGNMENT',
    name: 'Vehicle assignment',
    status_id: 4, // Assigned
    isSelected: false,
  },
  {
    key: 'BOOKING_CONFIRMATION',
    name: 'Booking Confirmation',
    isSelected: false,
  },
  {
    key: 'REPORTED',
    name: 'Reported',
    isSelected: false,
  },
  {
    key: 'TRUCK_IN',
    name: 'Truck In',
    status_id: 5, // Arrived
    isSelected: false,
  },
  {
    key: 'REACHED_LOADING_POINT',
    name: 'Reached Loading Point',
    isSelected: false,
  },
  {
    key: 'START_LOAD',
    name: 'Start Load',
    isSelected: false,
  },
  {
    key: 'END_LOAD',
    name: 'End Load',
    isSelected: false,
  },
  {
    key: 'TRUCK_OUT',
    name: 'Truck Out',
    status_id: 6, // Dispatched
    isSelected: false,
  },
  {
    key: 'MARK_DELIVER',
    name: 'Mark As Delivered',
    status_id: 7, // Delivered
    sec_status_id: 23, // Delivery Pending
    mandatory: true,
    isSelected: true,
  },
// {
//   key: 'GRN',
//   name: 'GRN',
//   status_id: 7, // Dispatched
//   isSelected: false,
// },
];

export default workflowEventsList;
